import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Components
import { Text } from './..'

// Styles
import styles from './Tab.module.scss'

const Tab = ({ label, onClick, activeTab }) => {
  const isActiveTab = activeTab === label

  return (
    <li key={label} className={styles.tabItem}>
      <Text
        className={classnames(
          styles.tabBtn,
          isActiveTab && styles.activeTabBtn
        )}
        element='button'
        weight='semibold'
        color={isActiveTab ? 'white' : 'gray'}
        onClick={onClick}
        name={label}
        value={label}
      >
        {label}
      </Text>
    </li>
  )
}

Tab.displayName = 'Tab'

Tab.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  activeTab: PropTypes.string,
}

export default Tab
